import styled from 'styled-components';

export const FooterStyles = styled.footer`
  position: relative;
  text-align: left;
  font-size: 12px;
  line-height: 1.5;
  padding: 16px 20px;
  min-height: 120px;

  @media (max-width: 600px) {
    padding: 14px 16px 24px;
  }
`;
